import * as ActionType from "../actionTypes";

export default (state = {}, action) => {
  switch(action.type){
    case ActionType.REQUEST_CREATE_TEMPLATE_DATA :

        return{
            ...state,
            loading:true,
            errorInfo:null,
            error:false,
            response:null
            
            }
    case ActionType.RECEIVED_CREATE_TEMPLATE_DATA :
        return{
            ...state,
            loading:false,
            errorInfo:null,
            error:false,
            response:action.res

        }
    case ActionType.ERROR_CREATE_TEMPLATE_DATA :
        return{
            ...state,
            loading:false,
            errorInfo:action.err,
            error:true,
            response:null
            }
    case ActionType.CLEAR_CREATE_TEMPLATE_DATA :
        return{
            
        }
    default : 
      return state    

  }
}